module.exports = __webpack_public_path__ + "static/media/calendar.f339e7bd.svg";